import React from 'react';
import ContentModelHandler from '../../utils/ContentModelHandler';
import EmptySpace from '../EmptySpace';
interface SectionInterface {
  id: string;
  sectionId?: string;
  topBackground: string;
  middleBackground: string;
  bottomBackground: string;
  backgroundDecor: string;
  fullWidth: boolean;
  topPadding: boolean;
  bottomPadding: boolean;
  extraClasses: string;
  rows: Array<{
    __typename: string;
    id: string;
    rowType: string;
    flexJustify: string;
    verticalAlignment: string;
    size: string;
    desktopSize: string;
    columns: Colums;
  }>;
}

type Colums = Array<{
  id: React.Key;
  mobileColumns: string;
  tabletColumns: string;
  desktopColumns: string;
  orderInDesktop: string;
  alignment: string;
  desktopAlignment: string;
  position: string;
  content: Array<object>;
  hideOnMobile: boolean;
}>;

function Section({
  id,
  sectionId,
  topBackground,
  middleBackground,
  bottomBackground,
  backgroundDecor,
  fullWidth,
  topPadding,
  bottomPadding,
  extraClasses,
  rows,
}: SectionInterface) {
  const renderEmptySpace = (size: string, desktopSize: string) => (
    <EmptySpace size={size} desktopSize={desktopSize} />
  );

  const renderRowItems = (columns: Colums) =>
    columns.map((item, index) => (
      <div
        key={index}
        className={`cl-col col-span-${item.mobileColumns} lg:order-${
          item.orderInDesktop
        } md:col-span-${item.tabletColumns} lg:col-span-${item.desktopColumns} cl-col--${
          item.alignment || 'left'
        } lg:cl-col--${item.desktopAlignment || 'left'} cl-col--${item.position} ${
          item.hideOnMobile ? 'cl-col--sm-hidden' : ''
        } `}
      >
        {item.content.map((content) => ContentModelHandler([content]))}
      </div>
    ));

  return (
    <section
      className={`cl-section${fullWidth ? ' cl-section--fullwidth' : ''}${
        !topPadding ? ' cl-section--no-pt' : ''
      }${!bottomPadding ? ' cl-section--no-pb' : ''}${
        topBackground ? ` cl-section--bg-top-${topBackground}` : ''
      }${middleBackground ? ` cl-section--bg-middle-${middleBackground}` : ''}${
        bottomBackground ? ` cl-section--bg-bottom-${bottomBackground}` : ''
      } ${extraClasses || ''}`}
      id={sectionId}
      key={id}
    >
      <div className='cl-section__bg'></div>
      <div className='cl-section__bg-decor'></div>
      <div className='cl-container'>
        {rows.map((row) => (
          <div
            key={row.id}
            className={`${
              row.rowType === 'grid' ? 'cl-row' : 'cl-row cl-row--flex'
            } cl-row--align-${row.verticalAlignment || 'top'}`}
          >
            {row.__typename === 'ContentfulEmptySpace'
              ? renderEmptySpace(row.size, row.desktopSize)
              : renderRowItems(row.columns)}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Section;
